/** Maintenance page — reassuring, on-brand, with status pulse. */
import { Wrench, Mail } from "lucide-react";
import { Container, Eyebrow, DisplayHeading, Lede, AccentItalic, Button } from "../components/ui";

export function MaintenancePage() {
  return (
    <section className="min-h-[70vh] grid place-items-center py-20" data-testid="maintenance-page">
      <Container>
        <div className="max-w-[640px] mx-auto text-center">
          <div className="inline-flex items-center gap-3 px-4 py-2 rounded-full bg-surface border border-line-2 mb-7">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse" />
            <span className="text-[12px] font-mono uppercase tracking-[0.16em] text-text-dim">
              Improvements underway
            </span>
          </div>
          <Eyebrow centered>
            <Wrench size={12} /> Scheduled maintenance
          </Eyebrow>
          <DisplayHeading className="mt-5">
            We are <AccentItalic>refining</AccentItalic> the campus.
          </DisplayHeading>
          <Lede className="mt-6 mx-auto">
            Nikhil Vatika Lab is performing a brief, scheduled upgrade. The platform will return
            shortly. Thank you for your patience — every improvement here serves your study.
          </Lede>
          <div className="mt-9 flex items-center justify-center gap-3 flex-wrap">
            <Button asChild>
              <a href="mailto:admissions@nikhilvatikalab.com">
                <Mail size={14} /> Contact admissions
              </a>
            </Button>
            <Button asChild variant="ghost">
              <a href="/">Try again</a>
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
